import React from 'react';

const STATUS_STYLES = {
  pending: { bg: 'bg-base-300', text: 'text-base-content/40', icon: '○' },
  created: { bg: 'bg-info/20', text: 'text-info', icon: '◐' },
  completed: { bg: 'bg-success/20', text: 'text-success', icon: '●' },
  skipped: { bg: 'bg-base-300', text: 'text-base-content/30', icon: '—' },
};

const TYPE_ICONS = {
  todo: '☑️',
  task: '📋',
  calendar_event: '📅',
};

/**
 * WorkflowStepProgress - Step timeline visualization for a workflow instance.
 */
export default function WorkflowStepProgress({ stepInstances = [], compact = false }) {
  if (compact) {
    return (
      <div className="flex items-center gap-1">
        {stepInstances.map((step, i) => {
          const style = STATUS_STYLES[step.status] || STATUS_STYLES.pending;
          return (
            <div
              key={step.stepId || i}
              className={`w-3 h-3 rounded-full ${style.bg} ${style.text}`}
              title={`${step.name}: ${step.status}`}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {stepInstances.map((step, i) => {
        const style = STATUS_STYLES[step.status] || STATUS_STYLES.pending;
        const isLast = i === stepInstances.length - 1;

        return (
          <div key={step.stepId || i} className="flex items-start gap-3">
            {/* Timeline indicator */}
            <div className="flex flex-col items-center">
              <div className={`w-8 h-8 rounded-full ${style.bg} flex items-center justify-center text-sm ${style.text}`}>
                {style.icon}
              </div>
              {!isLast && (
                <div className={`w-0.5 h-6 ${step.status === 'completed' ? 'bg-success/30' : 'bg-base-300'}`} />
              )}
            </div>

            {/* Step info */}
            <div className="flex-1 min-w-0 pb-2">
              <div className="flex items-center gap-2">
                <span className="text-sm">{TYPE_ICONS[step.type] || ''}</span>
                <span className={`font-medium text-sm ${step.status === 'completed' ? 'line-through text-base-content/50' : ''}`}>
                  {step.name}
                </span>
                <span className={`badge badge-xs ${
                  step.status === 'completed' ? 'badge-success' :
                  step.status === 'created' ? 'badge-info' :
                  step.status === 'skipped' ? 'badge-ghost' : 'badge-ghost'
                }`}>
                  {step.status}
                </span>
              </div>

              {step.assignedTo && (
                <p className="text-xs text-base-content/50 mt-0.5">
                  Assigned to: {step.assignedTo}
                </p>
              )}

              {step.completedAt && (
                <p className="text-xs text-base-content/40 mt-0.5">
                  Completed: {step.completedAt?.toDate?.()?.toLocaleDateString?.() || '—'}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
